<template>
  <vs-popup class="invite-friends-popup" title="" :active.sync="popupActive">

  <InviteFriends/>

  </vs-popup>
</template>

<script>

export default {
  props: {
  },
  data () {
    return {
      popupActive: false,
    }
  },
  computed: {
  },
  methods: {
    show () {
      this.$store.dispatch('ADDITIONAL_USER_INFO', { inviteFriendOpen: true })
      this.popupActive = true
    },
  },
}
</script>

<style land="scss">

  .vs-popup--header {
    border-radius: 2rem;
  }

  .vs-popup--title {
    background: #ffffff;
    border-radius: 2rem;
  }


  .vs-popup {
    border-radius: 2rem
  }
</style>
